import { Button } from "../../ui";
import ScheduleCard from "./ScheduleCard";

export default function ScheduleCalendar({
  items = [],
  currentDate,
  setCurrentDate,
  lang,
  onCardClick,
}) {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const today = new Date();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const startDay = firstDay.getDay();
  const daysInMonth = lastDay.getDate();

  const monthName = currentDate.toLocaleString(
    lang === "ar" ? "ar-SA" : "en-US",
    {
      month: "long",
      year: "numeric",
    }
  );

  const days = [];

  for (let i = 0; i < startDay; i++) {
    days.push(null);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    days.push(new Date(year, month, day));
  }

  const goPrev = () => setCurrentDate(new Date(year, month - 1, 1));
  const goNext = () => setCurrentDate(new Date(year, month + 1, 1));
  const goToday = () => setCurrentDate(new Date());

  const isToday = (date) => {
    if (!date) return false;

    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };

  const getItemsByDay = (date) => {
    if (!date) return [];

    return items.filter((item) => {
      const itemDate = new Date(item.crm.followUpEndDate);

      return (
        itemDate.getFullYear() === date.getFullYear() &&
        itemDate.getMonth() === date.getMonth() &&
        itemDate.getDate() === date.getDate()
      );
    });
  };

  const weekDays =
    lang === "ar"
      ? ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"]
      : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return (
    <div className="schedule-calendar">
      <div className="schedule-title-row">
        <div>
          <h2>{lang === "ar" ? "التقويم" : "Calendar"}</h2>
          <p>
            {lang === "ar"
              ? "مراجعة وترتيب المتابعات القادمة"
              : "Review and sort upcoming follow ups"}
          </p>
        </div>

        <Button
          type="button"
          variant="primary"
          appearance="soft"
          size="sm"
          className="today-btn"
          onClick={goToday}
        >
          {lang === "ar" ? "اليوم" : "Today"}
        </Button>
      </div>

      <div className="schedule-header">
        <Button type="button" variant="ghost" appearance="soft" size="sm" onClick={goPrev}>
          {lang === "ar" ? "السابق" : "Prev"}
        </Button>
        <h3>{monthName}</h3>
        <Button type="button" variant="ghost" appearance="soft" size="sm" onClick={goNext}>
          {lang === "ar" ? "التالي" : "Next"}
        </Button>
      </div>

      <div className="schedule-weekdays">
        {weekDays.map((day) => (
          <div key={day}>{day}</div>
        ))}
      </div>

      <div className="schedule-grid">
        {days.map((date, index) => {
          const dayItems = getItemsByDay(date);

          return (
            <div
              key={index}
              className={`schedule-day ${isToday(date) ? "today-day" : ""}`}
            >
              {date && (
                <>
                  <div className="day-header">
                    <span className="day-number">{date.getDate()}</span>

                    {dayItems.length > 0 && (
                      <span className="day-count">
                        {dayItems.length} {lang === "ar" ? "موعد" : "action"}
                      </span>
                    )}
                  </div>

                  <div className="day-items">
                    {dayItems.slice(0, 3).map((item) => (
                      <ScheduleCard
                        key={item._id}
                        item={item}
                        lang={lang}
                        onClick={() => onCardClick(item)}
                      />
                    ))}

                    {dayItems.length > 3 && (
                      <div className="more-items">
                        +{dayItems.length - 3} {lang === "ar" ? "المزيد" : "more"}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}